export const hasPermission = (props, arr) => {
  // Handle F5 refresh when user might not be loaded yet
  if (!props.user || typeof props.user !== 'object') {
    // During rehydration, check if we have a token to indicate we should wait
    const token = localStorage.getItem('token');
    if (token) {
      // User is likely being rehydrated, allow access to prevent 404
      return true;
    }
    return false;
  }
  
  if (props.user.user_type === 'Super User') return true;
  if (props.user.is_tenant_admin && !arr.includes("Super User")) return true;
  if (props.user.is_reseller_admin && !arr.includes("Super User")) return true;
  const permissions = props.user.permissions || {};
  for (let i = 0; i < arr.length; i++) if (permissions[arr[i]]) return true;
  return false;
};

export const hasPortalPermission = (props, permission) => {
  // Handle F5 refresh when user might not be loaded yet
  if (!props.user || typeof props.user !== 'object') {
    // During rehydration, check if we have a token to indicate we should wait
    const token = localStorage.getItem('token');
    if (token) {
      // User is likely being rehydrated, allow access to prevent 404
      return true;
    }
    return false;
  }
  
  return props.user.role?.status && props.user.role?.[permission];
};
